import Login from "./components/Admin/Login.vue";
import Dashboard from "./components/Admin/Dashboard.vue";
import Settings from "./components/Admin/Settings.vue";
import Employees from "./components/Admin/Employees.vue";
import SingleEmployee from "./components/Admin/SingleEmployee.vue";
import OverviewReport from "./components/Admin/OverviewReport.vue";
import DetailReport from "./components/Admin/DetailReport.vue";
import Admins from "./components/Admin/Admins.vue";
import MissingPunch from "./components/Admin/MissingPunch.vue";

export default {
    mode: "history",
    linkActiveClass: "current",
    routes: [
        { path: "/", component: Login, meta: { title: "Login" } },
        { path: "/settings", component: Settings, meta: { title: "Settings" } },
        { path: "/dashboard", component: Dashboard, meta: { title: "Dashboard" } },
        { path: "/employees", component: Employees, meta: { title: "Employees" } },
        { path: "/employees/:slug", component: SingleEmployee, meta: { title: "Employee Details" }, name: 'employees-detail' },
        { path: "/overview-report", component: OverviewReport, meta: { title: "Employee Overview Report" }, name: 'overview-report' },
        { path: "/detailed-report", component: DetailReport, meta: { title: "Employee Detail Report" }, name: 'detailed-report' },
        { path: "/admins", component: Admins, meta: { title: "Admins" }, name: 'admin' },
        { path: "/missing-punch-requests", component: MissingPunch, meta: { title: "Missing Punch Requests" }, name: 'Missing Punch Requests' },
    ]
}